export default {
  // Tabs
  tabUsers: 'Users',
  tabReferences: 'References',
  tabEkrm: 'EKRM',
  tabRoles: 'Roles',
  tabGroups: 'Groups',
  tabAuditTrail: 'Audit Trail',

  // Users tab - toolbar
  saveChanges: 'Save Changes',
  cancel: 'Cancel',
  unsavedChanges: '{count} unsaved changes',
  search: 'Search',

  // Users tab - table headers
  headerEmail: 'Email',
  headerModels: 'Models',
  headerActions: 'Actions',

  // Users tab - models
  selectModels: 'Select Models',
  pending: 'Pending',

  // Users tab - delete dialog
  deleteUserTooltip: 'Delete User',
  deleteDialogTitle: 'Warning',
  deleteDialogText: 'Deleting user: {userName}',
  deleteDialogConfirmation: 'This action cannot be undone. Are you sure?',
  deleteButton: 'Delete',
  deleting: 'Deleting...',

  // Alert messages
  alertClose: 'Close',
  saveSuccessMessage: 'Successfully saved changes for {count} user(s)',
  saveErrorMessage: 'Failed to save changes. Please try again.',
  saveErrorWithDetails: 'An error occurred while saving changes: {error}',
  cancelledMessage: 'Changes cancelled',
  deleteSuccessMessage: 'User {userName} deleted successfully',
  deleteErrorMessage: 'Failed to delete user: {error}',
  loadErrorMessage: 'Failed to load data. Please refresh the page or contact support if the issue persists.'
}
